import { ComponentProps, forwardRef } from 'react';

import FlexBox from './FlexBox';

type Props = ComponentProps<typeof FlexBox>;

export default forwardRef<HTMLDivElement, Props>((props, ref) => (
    <FlexBox ref={ref} direction="row" {...props} />
));
